import * as _ from 'lodash';
import React from 'react';
import Loadable from 'react-loadable';
import { Switch } from 'react-router-dom';

import EditableRoute from '@components/EditableRoute';
import PageWrapper from './components/PageWrapper';

const Loading = () => <div />;

const BiSearch = Loadable({
  loader: () => import('@modules/bi/pages/search'),
  loading: Loading,
});

const MergePropertyReport = Loadable({
  loader: () => import('@modules/bi/pages/mergeProperty'),
  loading: Loading,
});

const CreateNew = Loadable({
  loader: () => import('@modules/bi/pages/createNew'),
  loading: Loading,
});

const DashboardConfig = Loadable({
  loader: () => import('@modules/bi/pages/dashboardConfig'),
  loading: Loading,
});

const CreateDashboardConfig = Loadable({
  loader: () => import('@modules/bi/pages/createDashboardConfig'),
  loading: Loading,
});

const CreateDashboardQuery = Loadable({
  loader: () => import('@modules/bi/pages/createDashboardQuery'),
  loading: Loading,
});

const ReportRecord = Loadable({
  loader: () => import('@modules/bi/pages/reportRecord'),
  loading: Loading,
});

const SystemReportTotals = Loadable({
  loader: () => import('@modules/bi/pages/taxingUnitOptions'),
  loading: Loading,
});

const SystemReportRoll = Loadable({
  loader: () => import('@modules/bi/pages/taxingUnitOptions'),
  loading: Loading,
});

const EditReport = Loadable({
  loader: () => import('@modules/bi/pages/editReport'),
  loading: Loading,
});

const SmartListSearch = Loadable({
  loader: () => import('@modules/bi/pages/smartLists/search'),
  loading: Loading,
});

const CreateSmartList = Loadable({
  loader: () => import('@modules/bi/pages/smartLists/create'),
  loading: Loading,
});

const GainLossAnalysis = Loadable({
  loader: () => import('@modules/bi/pages/gainLossAnalysis'),
  loading: Loading,
});

const DataValidationLists = Loadable({
  loader: () => import('@modules/bi/pages/dataValidationLists'),
  loading: Loading,
});

const BradSQL = Loadable({
  loader: () => import('./pages/bradSQL'),
  loading: Loading,
});

const CreateNewQuery = Loadable({
  loader: () => import('./pages/bradSQL/createNewQuery'),
  loading: Loading,
});

const QueryRepository = Loadable({
  loader: () => import('./pages/bradSQL/queryRepository'),
  loading: Loading,
});

export const prefix = '/bi';

export const appRoutes = {};

export const pathToTitleAndComponent = {
  [prefix]: {
    component: Loadable({
      loader: () => import('./pages/Summary'),
      loading: Loading,
    }),
  },
  [prefix + '/search']: {
    title: 'Reports',
    component: BiSearch,
  },
  [prefix + '/analytics']: {
    title: 'BI Analytics',
    component: Loading,
  },
  [prefix + '/reports/appraisal-roll']: {
    title: 'BI Appraisal Roll',
    component: Loading,
  },
  [prefix + '/search/new']: {
    title: 'BI Create New Report Definition',
    component: CreateNew,
  },
  [prefix + '/search/report/:id']: {
    title: 'Report',
    component: ReportRecord,
  },
  [prefix + '/system-reports/totals']: {
    title: 'Totals',
    component: SystemReportTotals,
  },
  [prefix + '/system-reports/roll']: {
    title: 'Roll',
    component: SystemReportRoll,
  },
  [prefix + '/edit/:id']: {
    title: 'Edit Report',
    component: EditReport,
  },
  [prefix + '/reports/appraisal-roll/certified-totals']: {
    title: 'BI Certified Totals',
    component: Loading,
  },
  [prefix + '/saved-reports']: {
    title: 'BI Saved Reports',
    component: Loading,
  },
  [prefix + '/business-intelligence']: {
    title: 'BI Business Intelligence',
    component: Loading,
  },
  [prefix + '/business-rules']: {
    title: 'BI Business Rules',
    component: Loading,
  },
  [prefix + '/smart-lists/search']: {
    title: 'Smart Lists',
    component: SmartListSearch,
  },
  [prefix + '/smart-lists/create']: {
    title: 'Smart Lists',
    component: CreateSmartList,
  },
  [prefix + '/smart-lists/:id']: {
    title: 'Smart Lists',
    component: CreateSmartList,
  },
  [prefix + '/data-validation/gain-loss-analysis']: {
    title: 'Gain/Loss Analysis',
    component: GainLossAnalysis,
  },
  [prefix + '/data-validation/data-validation-lists']: {
    title: 'Data Validation Lists',
    component: DataValidationLists,
  },
  [prefix + '/system-reports/merged-property']: {
    title: 'Merge Property Report',
    component: MergePropertyReport,
  },
  [prefix + '/system-reports/split-property']: {
    title: 'Split Property Report',
    component: MergePropertyReport,
  },
  [prefix + '/system-reports/newly-created-property']: {
    title: 'Newly Created Property Report',
    component: MergePropertyReport,
  },
  [prefix + '/system-reports/operations-survey']: {
    title: 'Operations Survey',
    component: MergePropertyReport,
  },
  [prefix + '/system-reports/income-worksheets']: {
    title: 'Income Worksheets',
    component: MergePropertyReport,
  },
  [prefix + '/system-reports/new-subdivision-list']: {
    title: 'New Subdivision List',
    component: MergePropertyReport,
  },
  [prefix + '/system-reports/improvement-pricing-schedules']: {
    title: 'Improvement Pricing Schedules',
    component: MergePropertyReport,
  },
  [prefix + '/system-reports/land-pricing-schedules']: {
    title: 'Land Pricing Schedules',
    component: MergePropertyReport,
  },
  [prefix + '/dashboard-config']: {
    title: 'Appraisal Dashboard Configuration',
    component: DashboardConfig,
  },
  [prefix + '/dashboard-config/create']: {
    title: 'Appraisal Dashboard Configuration',
    component: CreateDashboardConfig,
  },
  [prefix + '/dashboard-config/:id']: {
    title: 'Appraisal Dashboard Configuration',
    component: CreateDashboardConfig,
  },
  [prefix + '/dashboard-config/:id/query/:queryid']: {
    title: 'Appraisal Dashboard Configuration',
    component: CreateDashboardQuery,
  },
  [prefix + '/bradsql']: {
    title: 'BradSQL',
    component: BradSQL,
  },
  [prefix + '/bradsql/create-query']: {
    title: 'Create New Query',
    component: CreateNewQuery,
  },
  [prefix + '/bradsql/query-repository']: {
    title: 'Query Repository',
    component: QueryRepository,
  },
  ...appRoutes,
};

export const parseHeaderTitle = (path) => {
  const paths = Object.keys(pathToTitleAndComponent);
  const currentPath = paths.find((p) => p !== prefix && path.startsWith(p)); // skip '/' route

  return _.get(pathToTitleAndComponent[currentPath], `title`, '');
};

const BiRoutes = (props) => (
  <PageWrapper {...props}>
    <Switch>
      {Object.entries(pathToTitleAndComponent).map(([path, { component }]) => (
        <EditableRoute exact key={path} path={path} component={component} />
      ))}
    </Switch>
  </PageWrapper>
);

export default BiRoutes;
